// eslint-disable-next-line import/no-cycle
import { NotificationsEntity } from '../../api/ORM/Schemas/notifications.schema';

export interface Notification
  extends Omit<NotificationsEntity, 'id' | 'firm' | 'client'> {
  id?: number;
}

export enum NotificationTypes {
  newFileShared = 'new_file_shared',
  newConnectionRequested = 'new_connection_request',
  newFileUploaded = 'new_file_uploaded',
  investorReportCardAnswer = 'investor_report_card_answer',
  newConnectionApproved = 'new_connection_approved',
}
